module.exports = __webpack_public_path__ + "static/img/4.97523a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/sp/4.png
// module id = 7Y8m
// module chunks = 0